import React, { useEffect } from "react";
import "../styles/newBuy.scss";
import "../styles/datepicker.scss";
import "../styles/discountCard.scss";
import { useDispatch } from "react-redux";
import { initAppBrowser } from "@actions/initApp";
import loadable from "@loadable/component";
const NewBuyMain = loadable(() =>
  import(/* webpackChunkName: "NewBuyMain" */ "../components/NewBuyMain")
);
const NewBuyCategories = loadable(() =>
  import(
    /* webpackChunkName: "NewBuyCategories" */ "../components/NewBuyCategories"
  )
);

const NewBuy = ({ showCategoryPage }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initAppBrowser(["messages", "categories", "new"]));
  }, []);
  return showCategoryPage ? <NewBuyCategories /> : <NewBuyMain />;
};

export default NewBuy;
